<!-- 占比分析 -->
<template>
    <div class="analysis_wrap">
        <div class="profile_area" v-if="isShowArea">
            <div class="area_select" @click="checkArea">
                <span>{{ selectArea }}</span>
                <img src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt />
            </div>
        </div>
        <div class="profile_pie">
            <pieChart :pieData='pieData' v-if="pieCount > 0" :linepieCount="linepieCount"></pieChart>
            <div class="noScenicList" v-else>
                <div class="profile_line_totle">
                    <div>资源等级占比分析</div>
                </div>
                <div class="noScenic">
                    <div class="noScenicItem">
                        <div class="noScenicItemImg">
                        <img src="@/assets/appointment/ic_wuxingxi@3x.png" alt>
                        </div>
                        <div class="noScenicItemContent">
                        该筛选条件下，没有查询到任何数据哦
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile_pie_pie"></div>
        <div class="profile_pie">
            <div class="profile_line_totle">
                <div>资源类型占比分析</div>
                <div class="profile_line_right" @click="bandleScenery">
                    <span>{{ scenery }}</span>
                    <img src="@/assets/resourcesManage/ic_jiantou_down2@2x.png" alt="">
                </div>
            </div>
            <div v-if="rankCount > 0">
                <RankChart :rankList="rankList" :isChartHeight="isChartHeight"></RankChart>
                <div class="profile_line_mone" v-if="rankList.length > 5">
                    <div class="profile_line_box" @click="searchMore" v-if="isShowBtn">
                        <span>展开更多</span>
                        <img src="@/assets/resourcesManage/arrowbtm.png" alt="">
                    </div>
                </div>
            </div>
            <div class="noScenicList" v-else>
                <div class="noScenic">
                <div class="noScenicItem">
                    <div class="noScenicItemImg">
                    <img src="@/assets/appointment/ic_wuxingxi@3x.png" alt>
                    </div>
                    <div class="noScenicItemContent">
                    该筛选条件下，没有查询到任何数据哦
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- 区域 -->
        <common-picker ref="commonpicker" :typeList="typeListCity" :cols="cols"  @getTypeValue="getCityValue"></common-picker>
        <!-- 地文景观 -->
        <common-picker ref="commonpickerScenery" :typeList="typeListScenery" :cols="colsItem" @getTypeValue="changeScenery"></common-picker>
    </div>
</template>

<script>
import api from '../../../../../service/modules/resourcesManage';
import commonPicker from '../../../../components/base/commonPickerTwo';
import pieChart from '../../../components/workOrderPieChart';
import RankChart from '../../../components/RankChartsRate';
import { timeType1 } from '../../../../../utils/configJson';

export default {
    components: {
        commonPicker,
        pieChart,
        RankChart
    },
    data () {
        return {
            isShowArea: true,
            selectArea: '全省',
            scenery: '全部类型',
            typeListCity: [],
            typeListScenery: timeType1,
            cols: 2,
            colsItem: 2,
            pieData: [],
            pieCount: 0,
            rankList: [],
            rankCount: 0,
            isChartHeight: false,
            level: localStorage.getItem('level'),
            areaCode: '',
            regionLevel: '',
            regionId: '',
            classifyLevel: '',
            classifyId: '',
            isShowBtn: true,
            linepieCount: 0
        }
    },
    created () {
        this.getDirectoriesScoreLevelPercentage();
        this.getDirectoriesCodingClassifyPercentage();
        this.getPercentageRegions();
        this.getPercentageClassify();
    },
    methods: {
        checkArea () {
            this.$refs.commonpicker.showPicker();
        },
        /** 区域下拉 */
        getCityValue (val) {
            if (val && val.length === 3) {
                if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text === '全部') {
                    this.selectArea = '全省';
                    this.areaCode = '';
                    this.regionLevel = '';
                    this.regionId = '';
                } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text === '全部' && val[0].text !== '全部') {
                    this.selectArea = val[0].text;
                    this.areaCode = val[0].value;
                    this.regionLevel = val[0].level;
                    this.regionId = val[0].id;
                } else if (((val[2] && val[2].text === '全部') || val[2] == undefined) && val[1].text !== '全部') {
                    this.selectArea = val[1].text;
                    this.areaCode = val[1].value;
                    this.regionLevel = val[1].level;
                    this.regionId = val[1].id;
                } else {
                    this.selectArea = val[2].text;
                    this.areaCode = val[2].value;
                    this.regionLevel = val[2].level;
                    this.regionId = val[2].id;
                }
            } else if (val && val.length === 2) {
                if (val[1].text === '全部') {
                    this.selectArea = val[0].text;
                    this.areaCode = val[0].value;
                    this.regionLevel = val[0].level;
                    this.regionId = val[0].id;
                } else {
                    this.selectArea = val[1].text;
                    this.areaCode = val[1].value;
                    this.regionLevel = val[1].level;
                    this.regionId = val[1].id;
                }
            } else if (val && val.length === 1) {
                this.selectArea = val[0].text;
                this.areaCode = val[0].value;
                this.regionLevel = val[0].level;
                this.regionId = val[0].id;
            }

           this.pieData = [];
           this.rankList = [];
           this.getDirectoriesScoreLevelPercentage();
           this.getDirectoriesCodingClassifyPercentage();
        },
        bandleScenery (val) {
            this.$refs.commonpickerScenery.showPicker();
        },
        searchMore () {
            this.isChartHeight = !this.isChartHeight;
            this.isShowBtn = false;
        },

        /**  */
        async getPercentageClassify () {
            let res = await api.getPercentageClassify();
            if (res.ret === 0) {
                let obj = {
                    text: '全部类型',
                    value: '',
                    shortName: '全部类型',
                    level: '',
                    children: [
                        {
                            text: '全部',
                            value: '',
                            shortName: '全部',
                            level: ''
                        }
                    ]
                }
                let arr = res.data.map(item => {
                    return {
                        text: item.classifyName,
                        shortName: item.classifyName,
                        level: item.classifyLevel,
                        value: item.id,
                        pId: item.pId,
                        children: item.children.map(e => {
                            return {
                                text: e.classifyName,
                                shortName: e.classifyName,
                                level: e.classifyLevel,
                                value: e.id,
                                pId: e.pId
                            }
                        })
                    }
                })
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].children) {
                        let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                        let newArr = arr[i].children.concat([]);
                        arr[i].children = cityChild.concat(newArr)
                    }
                }
                arr.unshift(obj);
                this.typeListScenery = [];
                this.typeListScenery.push(arr);
            }
        },
        /** 占比类型分析下拉 */
        changeScenery (val) {
            if (val && val.length === 2) {
               if (val[1].text === '全部') {
                   this.scenery = val[0].text;
                   this.classifyLevel = val[0].level;
                   this.classifyId = val[0].value;
               } else {
                    this.scenery = val[1].text;
                    this.classifyLevel = val[1].level;
                   this.classifyId = val[1].value;
               }
           } else if (val && val.length === 1) {
                this.scenery = val[0].text;
                this.classifyLevel = val[0].level;
                this.classifyId = val[0].value;
           }
           this.isChartHeight = false;
           this.isShowBtn = true;
           this.rankList = [];
           this.getDirectoriesCodingClassifyPercentage();
        },

        async getPercentageRegions () {
            let res = await api.getPercentageRegions();
            if (res.ret === 0) {
                if (this.level == 1) {
                    this.selectArea = '全省';
                    this.cols = 3;
                    let obj = {
                        text: '全省',
                        shortName: '全省',
                        value: '',
                        level: '',
                        id: '',
                        pId: '',
                        children: [
                            {
                                text: '全部',
                                shortName: '全部',
                                value: '',
                                level: '',
                                id: '',
                                pId: '',
                                children: [
                                    {
                                        text: '全部',
                                        shortName: '全部',
                                        value: '',
                                        level: '',
                                        id: '',
                                        pId: ''
                                    }
                                ]
                            }
                        ]
                    }
                    let arr = res.data.map(item => {
                        return {
                            text: item.fullName,
                            shortName: item.fullName,
                            value: item.areaCode,
                            level: item.regionLevel,
                            id: item.id,
                            pId: item.pId,
                            children: item.children.map(e => {
                                return {
                                    text: e.fullName,
                                    shortName: e.fullName,
                                    value: e.areaCode,
                                    level: e.regionLevel,
                                    id: e.id,
                                    pId: e.pId,
                                    children: e.children.map(el => {
                                        return {
                                            text: el.fullName,
                                            shortName: el.fullName,
                                            value: el.areaCode,
                                            level: el.regionLevel,
                                            id: el.id,
                                            pId: el.pId,
                                        }
                                    })
                                }
                            })
                        }
                    })
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].children) {
                            let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                            let newArr = arr[i].children.concat([]);
                            arr[i].children = cityChild.concat(newArr)
                        }
                        for (var j = 0; j < arr[i].children.length; j++) {
                            if (arr[i].children[j].children) {
                                let cityChildren = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                                let newArr1 = arr[i].children[j].children.concat([]);
                                arr[i].children[j].children = cityChildren.concat(newArr1)
                            }
                        }
                    }
                    arr.unshift(obj);
                    this.typeListCity = [];
                    this.typeListCity.push(arr);
                } else if (this.level == 2) {
                    this.selectArea = res.data[0].fullName;
                    let objBrr = {
                        text: res.data[0].fullName,
                        shortName: res.data[0].fullName,
                        level: res.data[0].regionLevel,
                        id: res.data[0].id,
                        value: res.data[0].areaCode,
                        pId: res.data[0].pId,
                        children: [
                            {
                                text: '全部',
                                shortName: '全部',
                                value: '',
                                level: '',
                                id: '',
                                pId: ''
                            }
                        ]
                    }
                    let brr = res.data[0].children.map(item => {
                        return {
                            text: item.fullName,
                            shortName: item.fullName,
                            value: item.areaCode,
                            level: item.regionLevel,
                            id: item.id,
                            pId: item.pId,
                            children: item.children.map(e => {
                                return {
                                    text: e.fullName,
                                    shortName: e.fullName,
                                    value: e.areaCode,
                                    level: e.regionLevel,
                                    id: e.id,
                                    pId: e.pId,
                                    
                                }
                            })
                        }
                    })
                    for (var i = 0; i < brr.length; i++) {
                        if (brr[i].children) {
                            let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                            let newArr = brr[i].children.concat([]);
                            brr[i].children = cityChild.concat(newArr)
                        }
                    }
                    brr.unshift(objBrr);
                    this.typeListCity = [];
                    this.typeListCity.push(brr);
                } else if (this.level == 3) {
                    this.selectArea = res.data[0].fullName;
                    let crr = res.data.map(item => {
                        return {
                            text: item.fullName,
                            shortName: item.fullName,
                            value: item.areaCode,
                            level: item.regionLevel,
                            id: item.id,
                            pId: item.pId,
                            children: item.children.map(e => {
                                return {
                                    text: e.fullName,
                                    shortName: e.fullName,
                                    value: e.areaCode,
                                    level: e.regionLevel,
                                    id: e.id,
                                    pId: e.pId
                                }
                            })
                        }
                    })
                    for (var i = 0; i < crr.length; i++) {
                        if (crr[i].children) {
                            let cityChild = [{ text: '全部', value: '', shortName: '全部', level: '' }];
                            let newArr = crr[i].children.concat([]);
                            crr[i].children = cityChild.concat(newArr)
                        }
                    }
                    this.typeListCity = [];
                    this.typeListCity.push(crr);
                }
            }
        },

        /** 占比分析list */
        async getDirectoriesCodingClassifyPercentage () {
            let res = await api.getDirectoriesCodingClassifyPercentage({ regionId: this.regionId, classifyId: this.classifyId, classifyLevel: this.classifyLevel });
            // let res = await api.getDirectoriesCodingClassifyPercentage({ areaCode: this.areaCode, regionLevel: this.regionLevel, classifyId: this.classifyId, classifyLevel: this.classifyLevel });
            if (res.ret === 0) {
                this.rankCount = res.data.reduce(function(prev, item){
                    return prev + item.num;
                }, 0)
                let arr = res.data.sort(function(a, b){
                    return b.num - a.num
                })
                this.rankList = arr.length ? arr.map(item => {
                    return {
                        city: item.name,
                        mark: this.rankCount > 0 ? ((item.num / this.rankCount) * 100).toFixed(2) : '0'
                    }
                }) : []
            }
        },

        async getDirectoriesScoreLevelPercentage () {
            let res = await api.getDirectoriesScoreLevelPercentage({ regionId: this.regionId });
            // let res = await api.getDirectoriesScoreLevelPercentage({ areaCode: this.areaCode, regionLevel: this.regionLevel });
            if (res.ret === 0) {
                this.pieCount = res.data.reduce(function(prev, item){
                    return prev + item.num;
                }, 0)
                let arr = res.data.sort(function(a, b){
                    let obj = ['五级', '四级', '三级', '二级', '一级', '未获等级']; 
                    return obj.indexOf(a.name) - obj.indexOf(b.name)
                })
                this.pieData = arr.map(item => {
                    return {
                        value: item.num,
                        name: item.name === '未获等级' ? '未评级' : item.name,
                        radito: this.pieCount > 0 ? ((item.num / this.pieCount) * 100).toFixed(2) : '0'
                    }
                })
                this.linepieCount = 0;
                this.pieData.forEach(el => {
                    if (el.value > 0) {
                        this.linepieCount++;
                    }
                });
            }

        }
    },
    destroyed () {
        this.pieData = [];
        this.rankList = [];
    }
}
</script>

<style lang="less" scoped>
.analysis_wrap {
    padding: 0 12px;
    .profile_area {
        margin: 12px 0;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
            display: inline-block;
            margin-left: 4px;
            width: 6px;
            height: 4px;
            vertical-align: middle;
        }
    }
    .profile_pie_pie {
        // height: 16px;
    }
    .profile_pie {
        margin-bottom: 12px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        border: 1px solid #fff;
        .profile_line_totle {
            font-size: 14px;
            font-weight: bold;
            color: #333;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 16px 16px 8px 16px;
            .profile_line_right {
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    display: inline-block;
                    margin-left: 4px;
                    width: 6px;
                    height: 4px;
                    vertical-align: middle;
                }
            }
        }
        .profile_line_mone {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 24px;
            .profile_line_box {
                color: #666;
                font-size: 12px;
                font-weight: 400;
                 display: flex;
                justify-content: center;
                align-items: center;
                img{
                    display: inline-block;
                    margin-left: 4px;
                    width: 12px;
                    height: 12px;
                    vertical-align: middle;
                }
            }
        }
        .noScenicList {
            height: 100%;
            .noScenic {
            display: flex;
            justify-content: center;
            align-items: center;
            // margin-top: 120px;
            height: 155px;
            .noScenicItem {
                margin: 30px 0;
                .noScenicItemImg {
                margin-bottom: 24px;
                display: flex;
                justify-content: center;
                img {
                    display: inline-block;
                    width: 74px;
                    height: 62px;
                }
                }
                .noScenicItemContent {
                font-size: 14px;
                color: #999999;
                }
            }
            }
        }
    }
    /deep/.distribution_wrap .md-popup-mask {
        background-color: rgba(37, 38, 45, 0.3);
    }
    /deep/.md-popup-mask {
      background-color: rgba(37,38,45,.3);
    }
    /deep/.van-overlay {
      background-color: rgba(37,38,45,.3);
    }
}
</style>
